import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { LicenseDataService } from '../../Services/LicenseDataService';
import { loginRequest } from '../../authConfig';
import './LicensePage.css';

const LicensePage = () => {
    const { instance, accounts } = useMsal();
    const [licenseKey, setLicenseKey] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!licenseKey) {
            setError('Please enter a license key.');
            return;
        }

        try {
            const request = { ...loginRequest, account: accounts[0] };
            const response = await instance.acquireTokenSilent(request);

            // Submit license key to backend for validation
            const result = await LicenseDataService.addLicense( licenseKey, response.accessToken);
            
            if (result && result.status == 200) {
                navigate('/home'); // Redirect to home on successful validation
            } else {
                setError('Invalid license key.');
            }
        } catch (error) {
            console.error('License submission failed', error);
            setError('Failed to validate license.');
        }
    };

    return (
        <div className='license-page d-flex'>
                <div className={`d-flex align-items-center justify-content-center w-100`}>
                    <div className={`card license-card w-75`}>
                        <div className="card-body p-5">
                            <h2>License Key</h2>
                            <p>Enter your license key by using the input below.</p>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    value={licenseKey}
                                    onChange={(e) => setLicenseKey(e.target.value)}
                                    // placeholder="License Key"
                                    className='form-control mt-4'
                                />
                                {accounts.length > 0 && <small>Currently logged in as {accounts[0].username}</small>}
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                <div className='mt-4 d-flex justify-content-end'>
                                    <button type="submit" className='btn btn-primary'>Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default LicensePage;
